import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Row, Space, Spin } from 'antd'
import { isEmpty } from 'lodash'

import { UpdateDataText } from '../../../core/components/sections'

import {
  CategoryBreadcrumbs,
  HistoryLink,
} from '../../../common/components/sections'
import { StyledPageSubTitle } from '../../../common/components/styled'
import { APP_ROUTES, EVENT_METADATA_TYPES } from '../../../common/constants'
import {
  renderSimpleUpdateEvent,
  showErrorNotification,
} from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { useDietCategoryQuery } from '../../hooks'
import { DietCategorySimpleDetailsForm } from '../forms'

const DietCategoryDetailsPage = () => {
  const { id } = useParams()

  const {
    isLoading: isFetchLoading,
    error: fetchError,
    data,
  } = useDietCategoryQuery(id)

  useDocumentTitle(`${data?.name || 'Loading Diet Category...'}`)

  useEffect(() => {
    if (fetchError) {
      showErrorNotification({
        title: 'Diet Category error',
        description: fetchError,
      })
    }
  }, [fetchError])

  return isFetchLoading || isEmpty(data) ? (
    <Spin />
  ) : (
    <>
      <StyledPageSubTitle>
        <Row justify="space-between">
          <Col span={12}>
            <CategoryBreadcrumbs
              idPath={data.node.idPath}
              namePath={data.node.namePath}
              rootAppRoute={APP_ROUTES.DIETS}
              categoryAppRoute={APP_ROUTES.DIET_CATEGORIES}
            />
          </Col>

          <Space>
            <UpdateDataText
              updatedAt={data.updatedAt}
              updatedBy={data.updatedBy?.name}
            />

            <HistoryLink
              renderEvent={renderSimpleUpdateEvent}
              entityId={id}
              eventMetadataTypes={[EVENT_METADATA_TYPES.DIET_CATEGORY]}
            />
          </Space>
        </Row>
      </StyledPageSubTitle>
      <DietCategorySimpleDetailsForm
        id={data.id}
        name={data.name}
        description={data.description}
        descriptionUrl={data.descriptionUrl}
        maxPosition={data.maxPosition}
        position={data.position}
      />
    </>
  )
}

export default DietCategoryDetailsPage
